import { CallConnectionState } from "./index.types";

export const CONNECTION_STATUS_MAP: Record<CallConnectionState, {
  label: string | null;
  ariaLabel: string;
}> = {
  stable: {
    label: null,
    ariaLabel: 'Connection is stable'
  },
  unstable: {
    label: 'Weak connection',
    ariaLabel: 'Connection is weak'
  },
  poor: {
    label: 'Poor connection',
    ariaLabel: 'Connection is poor'
  },
  off: {
    label: 'No connection',
    ariaLabel: 'No connection'
  }
};

export const POOR_CONNECTION_POPOVER_MESSAGE = 'Your connection seems to be poor. Please check your network.';